<div class="header">
    <h1 class="dialog-title">Planning vastzetten</h1>
    <button mat-icon-button matDialogClose>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="dialog-content" mat-dialog-content>
    <p>De planning is nu vastgezet tot en met {{ fixedDate | date: 'EEEE d MMMM yyyy' }}.</p>
</div>
<div class="actions" mat-dialog-actions>
    @if (mayFixDay) {
        <button class="button-left" (click)="fixSingleDay()" color="primary" mat-button>
            Zet {{ day.date | date: 'EEEE d MMMM' }} vast
        </button>
    } @else {
        <button class="button-left" disabled mat-button>
            <span class="capitalized-date">{{ day.date | date: 'EEEE d MMMM' }}</span> staat al vast
        </button>
    }
    @if (mayFixPlanning) {
        <button class="button-right" (click)="fixPlanning()" color="primary" mat-raised-button>
            Zet vast t/m {{ day.date | date: 'EEEE d MMMM' }}
        </button>
    }
</div>
